/**
 * created by hezq on 2019-08-29
 *
 * description： 弹出窗插件
 *
 */
export default class Dialog {
	/**
	 * description： 构造函数
	 * @param {Object} arg 属性集合
	 * @param {String} arg.pkid 弹出窗id
	 * @param {String} arg.class 弹出窗内容区域class
	 * @param {Number} arg.zIndex 弹出窗的层级
	 * @param {String} arg.title 弹出窗标题
	 * @param {Boolean} arg.closeOnClick 弹出窗是否可以通过点击遮罩层关闭
	 * @param {Number} arg.width 弹出框宽度
	 * @param {String} arg.speCss 弹出框自定义 class
	 * @param {String} arg.speCss1 弹出框自定义 class（不明白为什么要写两个）
	 * @param {String} arg.contentHTML 弹出窗中间内容
	 *
	 * created by hezq on 2019-08-29
	 *
	 */
	constructor (arg) {
		arg = arg || {}
		// 弹出窗唯一标识
		this.pkid = arg.pkid || new Date().getTime()
		// 弹出窗id
		this.id = 'dialog_' + this.pkid
		// 弹出窗内容区域id
		this.contentId = 'dialog_content_' + this.pkid
		// 弹出窗内容区域class
		this.contentClass = arg.class || ''
		// 弹出窗的层级
		this.zIndex = arg.zIndex || 1000
		// 弹出窗标题
		this.title = arg.title || ''
		// 弹出窗是否可以通过点击遮罩层关闭
		this.closeOnClick = arg.closeOnClick !== false
		// 弹出框宽度
		this.speCss = arg.speCss || ''
		this.speCss1 = arg.speCss1 || ''
		// 宽度
		this.width = arg.width || null

		// 弹出窗html模版
		this.template = `<div class="Messagebox frame_popule frame_scoreInfobox bfff frame_evalmoduel_popule" id="${this.id}" style="z-index:${this.zIndex}; max-height:${window.document.body.offsetHeight - 30}px; overflow-y: auto; overflow-x: hidden; display: none; ${this.width ? `width: ${this.width}px` : ''};"><h5><span class="dialog_title">${this.title}</span><i class="iconfont icon-guanbi closeIcon"></i></h5><div id="${this.contentId}" class="${this.contentClass}" style="max-height:${window.document.body.offsetHeight - 120}px;overflow:auto;padding: 0 24px 20px;">${arg.contentHTML}</div></div>`
		// 渲染弹出窗
		this.render()
	}

	/**
	 * description： 弹出窗渲染
	 *
	 * created by hezq on 2019-08-29
	 *
	 */
	render () {
		// 判断弹窗是否已经添加
		if ($(`#${this.id}`).length < 1) {
			// 渲染遮罩层
			let maskHtml = `<div class="frame_mask" style="display:none;z-index:${this.zIndex - 1}" id="mask_${this.pkid}"></div>`

			if ($(`#mask_${this.pkid}`).length < 1) {
				$('body').append(maskHtml)
			}

			let self = this

			// 如果可以通过遮罩关闭弹出窗
			if (this.closeOnClick) {
				// 给遮罩层绑定关闭弹出窗事件
				$('body').on('click', '#mask_' + this.pkid, function () {
					self.close()
				})
			}

			// 给关闭图标添加事件
			$('body').on('click', '#' + this.id + ' .closeIcon', function () {
				self.close()
			})

			// 渲染弹出窗
			$('body').append(this.template)
			if (this.speCss.length > 0) {
				$(`#${this.id}`).removeClass('frame_popule')
				$(`#${this.id}`).addClass(this.speCss)
				$(`#${this.id}`).removeClass('frame_evalmoduel_popule')
				$(`#${this.id}`).addClass(this.speCss1)

				// $('.frame_normSetter ol li').css('width', '180px');
			}
		}
	}

	/**
	 * description： 更新弹窗内容
	 *
	 * created by panjm on 2019-08-29
	 *
	 */
	update (html) {
		// 更新弹窗内容
		$('#' + this.contentId).html(html)

		this.template = `<div class="Messagebox frame_popule frame_scoreInfobox bfff frame_evalmoduel_popule" id="${this.id}" style="z-index:${this.zIndex}; max-height:${window.document.body.offsetHeight - 30}px; overflow-y: auto; overflow-x: hidden; display: none; ${this.width ? `width: ${this.width}px` : ''};"><h5><span class="dialog_title">${this.title}</span><i class="iconfont icon-guanbi closeIcon"></i></h5><div id="${this.contentId}" class="${this.contentClass}" style="max-height:${window.document.body.offsetHeight - 120}px;overflow:auto;padding: 0 24px 20px;">${html}</div></div>`
	}

	/**
	 * description： 打开弹出窗
	 *
	 * created by hezq on 2019-08-29
	 *
	 */
	open () {
		// 先重置弹窗
		this.reset()

		let dialogEL = $('#dialog_' + this.pkid)

		if (dialogEL.size() === 0) {
			return
		}

		dialogEL.show()

		let maskEL = $('#mask_' + this.pkid)

		if (maskEL.size() === 0) {
			return
		}

		maskEL.show()

		// 打开弹窗时禁止父页面滚动
		$('body').css('overflow', 'hidden')
	}

	/**
	 * description： 关闭弹出窗
	 *
	 * created by hezq on 2019-08-29
	 *
	 */
	close () {
		let dialogEL = $('#dialog_' + this.pkid)

		if (dialogEL.size() === 0) {
			return
		}

		dialogEL.hide()

		let maskEL = $('#mask_' + this.pkid)

		if (maskEL.size() === 0) {
			return
		}

		maskEL.hide()

		// 关闭弹窗时恢复父页面滚动
		$('body').css('overflow', 'visible')
	}

	/**
   * description: 重置弹窗
	 *
   * created by zhouzt on 2019-08-30 15:12:38
   */
	reset () {
		$(`#${this.id}`).remove()

		this.render()
	}
}



// WEBPACK FOOTER //
// ./src/libs/dialog.js